/**
 * Collapsible — shared toggle logic for accordion & FAQ blocks
 *
 * @param {string} containerSelector  - Selector for collapsible containers
 * @param {string} triggerSelector    - Selector for trigger buttons within a container
 * @param {Object} [options]
 * @param {boolean} [options.singleExpand=false] - Force single-expand (close others on open)
 */
export function initCollapsible(containerSelector, triggerSelector, { singleExpand = false } = {}) {
  const containers = document.querySelectorAll(containerSelector);

  containers.forEach((container) => {
    const triggers = container.querySelectorAll(triggerSelector);

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        const panelId = trigger.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);

        if (!panel) return;

        // Single-expand: close all other items first
        if (singleExpand && !isExpanded) {
          triggers.forEach((otherTrigger) => {
            if (otherTrigger !== trigger) {
              const otherId = otherTrigger.getAttribute('aria-controls');
              const otherPanel = document.getElementById(otherId);

              otherTrigger.setAttribute('aria-expanded', 'false');
              if (otherPanel) {
                otherPanel.setAttribute('aria-hidden', 'true');
              }
            }
          });
        }

        // Toggle current item
        trigger.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        panel.setAttribute('aria-hidden', isExpanded ? 'true' : 'false');
      });
    });
  });
}
